import compile from 'string-template/compile'

const defaults = {
  badInput: 'Bad input',
  valueMissing: '{name} is required',
  tooShort: '{name} is too short. It must be at least {minlength} characters long',
  tooLong: '{name} is too long. It can only be {maxlength} characters long',
  typeMismatch: '{name} must match requested format.',
  emailMismatch: '{name} must be a valid email address.',
  urlMismatch: '{name} must be a valid url.',
  numberMismatch: '{name} must be a valid number.',
  rangeOverflow: '{name} must be less than or equal to {max}.',
  rangeUnderflow: '{name} must be greater than or equal to {min}.',
  stepMismatch: '{name} must match requested format.',
  patternMismatch: '{name} must match requested format.',
  creditCard: '{name} must be a valid credit card number.',
  exactLength: '{name} must contain exactly {exactLengthValue} characters.',
  phoneNumber: '{name} must be a valid phone number.',
}

class ValidationMessages {

  constructor() {
    // Compile default string templates
    this._defaultMessages = {}
    Object.entries(defaults)
      .forEach(([key, value]) => this._defaultMessages[key] = compile(value))

    this.customMessages = {} // user defined messages
  }

  overrideMessages(messages) {
    if(!messages) return
    Object.entries(messages)
      .forEach(([key, value]) => this.customMessages[key] = compile(value)) // Compile string template
  }

  /**
   * Returns a custom error message
   * @param  {VueComponent} vc        Validatable component
   * @param  {String}       errorType 
   */
  getErrorMessage(vc, errorType) {
    let orignalError = errorType
    errorType = snakeToCamelCase(errorType) // enforce camel cased errorTypes 

    let controlEl = vc.$refs.controlEl
    let data = {
      name: vc.label || 'Field',
      minlength: controlEl.getAttribute('minlength'),
      maxlength: controlEl.getAttribute('maxlength'),
      min: controlEl.getAttribute('min'),
      max: controlEl.getAttribute('max'),
      [`${errorType}Value`]: controlEl.getAttribute(orignalError) // for custom validation rules, supply the value that was defined on the rule
    }

    if(vc.errorMessage && vc.errorMessage[errorType]) // Error message defined on the component
      return vc.errorMessage[errorType]
    else if(this.customMessages[errorType]) // Custom locale error
      return this.customMessages[errorType](data)
    else if(this._defaultMessages[errorType]) // default message
      return this._defaultMessages[errorType](data)
    else
      return 'Error'
  }
}

function snakeToCamelCase(s) {
  return s.replace(/-([a-z])/g, g => g[1].toUpperCase())
}

export default new ValidationMessages()